// ** Redux Imports
import { combineReducers } from 'redux'

// ** Reducers Imports
import auth from './auth'
import navbar from './navbar'
import layout from './layout'
import setting from './system-setting'
import permission from './permission'

const rootReducer = combineReducers({
  auth,
  navbar,
  layout,
  setting,
  permission,
})

export default rootReducer
